import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Radio } from '../../design/inputs/radio/S_Radio';
import { S_ClampLines } from '../../design/misc/S_ClampLines';

interface IProps {
  id: string;
  label: string;
  onClick: () => void;
  checked: boolean;
  disabled?: boolean;
}

export const RadioInput = observer((props: IProps): ReactElement => {
  return (
    <S_Radio
      disabled={props.disabled}
      id={`radio-${props.id}`}
      onClick={props.onClick}
      checked={props.checked}
      label={<S_ClampLines text={props.label} />}
    />
  );
});
